

import { Plus } from 'lucide-react';

export const CategoryManager = () => {
  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">Categories</h1>
        <button className="bg-primary text-primary-foreground px-4 py-2 rounded-md flex items-center space-x-2 text-sm font-medium hover:bg-primary/90">
          <Plus className="w-4 h-4" />
          <span>New Category</span>
        </button>
      </div>
      <div className="border rounded-md p-8 text-center text-muted-foreground bg-card">
        Category management interface.
      </div>
    </div>
  );
};
